export enum DanflossProjectFields {
    hoseClassification = 'hoseClassification',
    hoseSize = 'hoseSize',
    hoseWorkingPressure = 'hoseWorkingPressure',
    hoseProduct = 'hoseProduct',
    preselectedHoseProduct = 'preselectedHoseProduct',

    fitting1Gender = 'fitting1Gender',
    fitting1ConnectionType = 'fitting1ConnectionType',
    fitting1ConnectionSize = 'fitting1ConnectionSize',
    fitting1Product = 'fitting1Product',
    fitting2Gender = 'fitting2Gender',
    fitting2ConnectionType = 'fitting2ConnectionType',
    fitting2ConnectionSize = 'fitting2ConnectionSize',
    fitting2Product = 'fitting2Product',
    fitting2SameAs1 = 'fitting2SameAs1',

    angleOfRotation = 'angleOfRotation',
    assemblyLength = 'assemblyLength',
    accessories = 'accessoryProduct',

    testingConfiguration = 'testingConfiguration',
    customerSerialNumber = 'customerSerialNumber',

    quantity = 'quantity',
    lengthType = 'lengthType',
    notes = 'notes',

    // Backend-computed, not rendered in UI or PDF — only forwarded into cart
    // event payload (mirrors how @arg,@demo,@greenline handles it).
    requiredComponents = 'requiredComponents',

    // Note this is a fake field, not existing on server
    tosAgreed = 'tosAgreed',
}
